import NextLink from "next/link"

import { Linkedin, Twitter } from "lucide-react"
import { useTheme } from "next-themes"

import CovalLogo from "@/components/icons/CovalLogo"

export const Navbar = () => {
  const { theme } = useTheme()

  return (
    <header className="sticky top-0 z-40 bg-white/70 px-6 backdrop-blur-md lg:px-8">
      <nav
        aria-label="Site"
        className="mx-auto flex max-w-7xl items-center justify-between py-4"
      >
        <div className="min-w-0 flex-1">
          <NextLink className="flex justify-start items-center gap-1" href="/">
            <CovalLogo theme={typeof theme === "string" ? theme : "light"} />
            <p className="font-bold text-inherit">COVAL</p>
          </NextLink>
        </div>

        <div className="flex items-center gap-4">
          <a
            href="https://x.com/covaldev"
            target="_blank"
            rel="noopener noreferrer"
            className="text-coval-text-muted hover:text-coval-text transition-colors"
          >
            <Twitter size={24} strokeWidth={1.75} />
          </a>
          <a
            href="https://www.linkedin.com/company/104128953"
            target="_blank"
            rel="noopener noreferrer"
            className="text-coval-text-muted hover:text-coval-text transition-colors"
          >
            <Linkedin size={24} strokeWidth={1.75} />
          </a>
        </div>
      </nav>
    </header>
  )
}
